import React, { useEffect, useRef, useState } from "react";
import CssTransition from "../../component/layout/css-transition";
import { Controller, useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import InputField from "../../component/input-field";
import Select from "react-select";
import { getScacData } from "../../redux/actions/todoPerformance";
import { useDispatch, useSelector } from "react-redux";
import { sanitizeInput } from "../../utils";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../component/modal-popup/customeModal";
import { useNavigate } from "react-router-dom";
import { createQuickBooking } from "../../redux/actions/booking";

const schema = yup.object({
  scac_code: yup.string().required("SCAC Code is required."),
  reference_type: yup.string().required("Reference type is required."),
  reference: yup.string().required("Reference is required."),
  internal_booking_ref_id: yup
    .string()
    .required("Internal reference no. is required."),
});

const trackingTypeOptions = [
  {
    label: "Bill of Lading",
    value: "BL",
  },
  {
    label: "Carriere Booking Ref.",
    value: "BK",
  },
];

const QuickBookingModal = ({
  id = "Quick Booking",
  modalOpen,
  setModalOpen,
}) => {
  const modalContent = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [shipppingLineOption, setShipppingLineOption] = useState([]);
  const { scacData } = useSelector((state) => state.todoPerformance);
  const [refType, setRefType] = useState("");
  const [scacCode, setScacCode] = useState("");
  const [isSubmit, setIsSubmit] = useState(false);

  const { control, handleSubmit, reset } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const defaultValues = {
    scac_code: "",
    reference_type: "",
    reference: "",
    internal_booking_ref_id: "",
  };

  useEffect(() => {
    dispatch(getScacData());
  }, []);

  useEffect(() => {
    if (scacData.length > 0) {
      const modifiedScacData = scacData.map((item) => {
        const obj = {
          label: item.shipping_line_name,
          value: item.scac_code,
        };
        return obj;
      });
      setShipppingLineOption(modifiedScacData);
    }
  }, [scacData]);

  const onSubmit = (data) => {
    setIsSubmit(true);
    const request = {
      payload: data,
      onSuccess: (res) => {
        if (res.status) {
          let activity_assignment_id = res.data;
          swal({
            content: (
              <CustomeModal
                type="success"
                title="Success!"
                content={`Booking created successfully.`}
                event="click"
                onClick={() => {
                  navigate(`/todo/performance/${activity_assignment_id}`);
                }}
              />
            ),
            buttons: false,
            closeOnClickOutside: false,
            closeOnEsc: false,
          });
        }
        setModalOpen(false);
        reset(defaultValues);
        setIsSubmit(false);
      },
      onError: (res) => {
        swal({
          content: (
            <CustomeModal type="error" title="Error!" content={res.message} />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        setIsSubmit(false);
      },
    };
    dispatch(createQuickBooking(request));
  };

  return (
    <>
      <CssTransition
        className="fixed inset-0 bg-slate-900 bg-opacity-30 z-50 transition-opacity"
        show={modalOpen}
        enter="transition ease-out duration-200"
        enterStart="opacity-0"
        enterEnd="opacity-100"
        leave="transition ease-out duration-100"
        leaveStart="opacity-100"
        leaveEnd="opacity-0"
        aria-hidden="true"
      />
      <CssTransition
        id={id}
        className="fixed inset-0 z-50 overflow-hidden flex items-center my-4 justify-center px-4 sm:px-6"
        role="dialog"
        aria-modal="true"
        show={modalOpen}
        enter="transition ease-in-out duration-200"
        enterStart="opacity-0 translate-y-4"
        enterEnd="opacity-100 translate-y-0"
        leave="transition ease-in-out duration-200"
        leaveStart="opacity-100 translate-y-0"
        leaveEnd="opacity-0 translate-y-4"
      >
        <div
          ref={modalContent}
          className="bg-white w-full overflow-auto max-w-2xl max-h-full rounded shadow-lg flex flex-col"
        >
          <div class="py-6 px-6 ">
            <h3 class="mb-8 text-xl font-medium text-gray-900 flex justify-center">
              Create Booking
            </h3>
            <form class="space-y-6" onSubmit={handleSubmit(onSubmit)}>
              <div class="flex flex-wrap -mx-3 mb-6">
                <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <Controller
                    name="internal_booking_ref_id"
                    control={control}
                    defaultValue={defaultValues.internal_booking_ref_id}
                    render={({
                      field: { value, onChange, ...field },
                      formState,
                    }) => (
                      <InputField
                        {...field}
                        type="text"
                        label="Internal Booking ID"
                        required={true}
                        placeholder="Enter Internal Reference Number"
                        onChange={(e) => {
                          const value = sanitizeInput(e.target.value);
                          onChange(value);
                        }}
                        value={value}
                        error={
                          formState.errors?.internal_booking_ref_id?.message ??
                          null
                        }
                      />
                    )}
                  />
                </div>

                <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <Controller
                    name="reference_type"
                    control={control}
                    defaultValue={defaultValues.reference_type}
                    render={({
                      field: { value, onChange, ...field },
                      formState,
                    }) => (
                      <div>
                        <label
                          for="reference_type"
                          class="block mb-1 text-sm font-medium text-gray-900"
                        >
                          Tracking Type
                          <span className="text-rose-500">*</span>
                        </label>
                        <Select
                          {...field}
                          name="reference_type"
                          className="unresetText text-left"
                          placeholder="Select Tracking Type"
                          menuPortalTarget={document.body}
                          menuPlacement="top"
                          options={trackingTypeOptions}
                          value={refType}
                          onChange={(val) => {
                            onChange(val?.value ?? "");
                            setRefType(val ? val : "");
                          }}
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          classNames={{
                            control: (style) => {
                              return `!border !shadow-sm ${
                                style.isFocused
                                  ? "!border-[--bg-color-300]/50"
                                  : "!border-slate-200 hover:!border-gray-300"
                              }`;
                            },
                            container: (style) => {
                              return "!h-[37.5px] !font-inter !text-sm";
                            },
                            menuList: (style) => {
                              return `!max-h-[200px]`;
                            },
                          }}
                          isClearable={true}
                        />
                        {formState?.errors?.reference_type?.message && (
                          <div className="text-xs mt-1 text-rose-500">
                            {formState?.errors?.reference_type?.message}!
                          </div>
                        )}
                      </div>
                    )}
                  />
                </div>
              </div>
              <div class="flex flex-wrap -mx-3 mb-6">
                <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <Controller
                    name="reference"
                    control={control}
                    render={({
                      field: { value, onChange, ...field },
                      formState,
                    }) => (
                      <InputField
                        {...field}
                        type="text"
                        label="Reference"
                        placeholder="Enter Tracking Reference"
                        required={true}
                        onChange={(e) => {
                          const value = sanitizeInput(e.target.value);
                          onChange(value);
                        }}
                        value={value}
                        error={formState.errors?.reference?.message ?? null}
                      />
                    )}
                  />
                </div>

                <div class="w-full md:w-1/2 px-3 mb-6 md:mb-0">
                  <Controller
                    name="scac_code"
                    control={control}
                    defaultValue={defaultValues.scac_code}
                    render={({
                      field: { value, onChange, ...field },
                      formState,
                    }) => (
                      <div>
                        <label
                          for="scac_code"
                          class="block mb-1 text-sm font-medium text-gray-900"
                        >
                          Shipping Line
                          <span className="text-rose-500">*</span>
                        </label>
                        <Select
                          {...field}
                          name="scac_code"
                          className="unresetText text-left"
                          placeholder="Select Shipping Line"
                          menuPortalTarget={document.body}
                          menuPlacement="top"
                          options={shipppingLineOption}
                          value={scacCode}
                          onChange={(val) => {
                            onChange(val?.value ?? "");
                            setScacCode(val ? val : "");
                          }}
                          styles={{
                            menuPortal: (base) => ({
                              ...base,
                              zIndex: 9999,
                            }),
                          }}
                          classNames={{
                            control: (style) => {
                              return `!border !shadow-sm ${
                                style.isFocused
                                  ? "!border-[--bg-color-300]/50"
                                  : "!border-slate-200 hover:!border-gray-300"
                              }`;
                            },
                            container: (style) => {
                              return "!h-[37.5px] !font-inter !text-sm";
                            },
                            menuList: (style) => {
                              return `!max-h-[200px]`;
                            },
                          }}
                          isClearable={true}
                        />
                        {formState?.errors?.scac_code?.message && (
                          <div className="text-xs mt-1 text-rose-500">
                            {formState?.errors?.scac_code?.message}!
                          </div>
                        )}
                      </div>
                    )}
                  />
                </div>
              </div>
              <div class="flex justify-end space-x-2">
                <button
                  type="button"
                  className={`btn ${
                    isSubmit ? "bg-slate-50 cursor-not-allowed" : "bg-slate-100"
                  } border-slate-200 hover:border-slate-300 text-slate-600`}
                  onClick={() => {
                    setModalOpen(false);
                    reset(defaultValues);
                  }}
                  disabled={isSubmit}
                >
                  Cancel
                </button>
                <button
                  className={`btn ${
                    isSubmit
                      ? "!bg-[--bg-color-300] cursor-not-allowed"
                      : "!bg-[--bg-color-500] hover:!bg-[--bg-color-600]"
                  } text-white`}
                  type="Submit"
                  disabled={isSubmit}
                >
                  {isSubmit ? (
                    <span className="w-5 h-5">
                      <svg
                        className="animate-spin w-5 h-5 fill-current shrink-0"
                        viewBox="0 0 16 16"
                      >
                        <path d="M8 16a7.928 7.928 0 01-3.428-.77l.857-1.807A6.006 6.006 0 0014 8c0-3.309-2.691-6-6-6a6.006 6.006 0 00-5.422 8.572l-1.806.859A7.929 7.929 0 010 8c0-4.411 3.589-8 8-8s8 3.589 8 8-3.589 8-8 8z" />
                      </svg>
                    </span>
                  ) : (
                    "Create"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </CssTransition>
    </>
  );
};

export default QuickBookingModal;
